
// @ts-nocheck
import { Vue, Component, Prop } from 'vue-property-decorator';
import { VCheckbox } from 'vuetify/lib';
import Icon from '@/components/Icons/Icon.vue';

@Component({
  extends: VCheckbox,
})
export default class QrCheckbox extends Vue {
  @Prop({ type: Boolean })
  indeterminate?: boolean;

  @Prop()
  border?: boolean;

  @Prop({ type: String, default: 'check-indetermined-system' })
  indeterminateIcon?: string;

  @Prop({ type: String, default: 'check-unchecked-system' })
  offIcon?: string;

  @Prop({ type: String, default: 'check-checked-system' })
  onIcon?: string;

  get classes(): object {
    return {
      'qr-checkbox': true,
      'qr-checkbox--border': this.border,
      'v-input--selection-controls': true,
      'v-input--checkbox': true,
      'v-input--indeterminate': this.inputIndeterminate,
    };
  }

  get computedIcon(): string {
    if (this.inputIndeterminate) {
      return this.indeterminateIcon;
    } else if (this.isActive) {
      return this.onIcon;
    } else {
      return this.offIcon;
    }
  }

  genCheckbox() {
    return this.$createElement(
      'div',
      {
        staticClass: 'v-input--selection-controls__input',
      },
      [
        this.$createElement(
          Icon,
          this.setTextColor(this.validationState, {
            props: {
              name: this.computedIcon,
              outline: !this.isActive,
            },
          })
        ),
        this.genInput('checkbox', {
          ...this.attrs$,
          'aria-checked': this.inputIndeterminate ? 'mixed' : this.isActive.toString(),
        }),
        this.$slots.default,
      ]
    );
  }
}
